import { useTranslation } from "react-i18next";
import StatusReportAction from "../../service/statusreport.actions";
import EnumChangeName from "../common/EnumChangeName";
import useOperationTranslation from "../../hooks/useOperationTranslation";

export interface LocationType {
  descr: string;
  id: string;
}

const ManipulateLocation = () => {
  const t = useOperationTranslation();
  const enumChangeName = EnumChangeName();
  const expectedEndLocation = (tenant: string): Promise<LocationType[]> => {
    return StatusReportAction()
      .getAllLocation(tenant)
      .then((response) =>
        response.map((element) => ({
          descr: `${element.locationEntityDesc} (${enumChangeName.locationType(
            element.type
          )})`,

          id: element.bpCode,
        }))
      );
  };

  return { expectedEndLocation };
};

export default ManipulateLocation;
